class AccountSettings.GeneralSettingsView extends Backbone.View
  template: JST["backbone/templates/account_settings/general"]
  events:
    'click #update-account-image': 'update'
    'click #remove-account-image': 'remove'
  URL: '/keepcon/settings/account_image'

  initialize: ({accountImageURL}) ->
    super
    @accountImageURL = accountImageURL
    @data = null

  render: ->
    @$el.html(@template accountImageURL: @accountImageURL)
    @$el.find('#remove-account-image').attr('disabled', (not @accountImageURL))
    @$el.find('#account-image-input').fileupload
      autoUpload: false
      url: @URL
      add: @add
    @

  add: (_, data) =>
    @data = data
    if @data.files and @data.files[0]
      reader = new FileReader()
      reader.onload = (event) =>
        @$el.find('#account-image-preview').attr('src', event.target.result).show()
        @$el.find('#update-account-image').attr('disabled', false)
        @$el.find('#remove-account-image').attr('disabled', true)

      reader.readAsDataURL(data.files[0])

  remove: (event) =>
    @data = null
    @$el.find('#update-account-image').attr('disabled', true)
    @$el.find('#account-image-preview').hide()

    $target = $(event.target)
    originalText = $target.html()
    $target.attr('disabled', true)
    $target.html I18n.t('account_settings.account_image.loading')
    $.ajax
      url: @URL
      type: 'DELETE'
      success: (response) =>
        if response.success
          $target.html originalText
          $('#main-header .account-image-container img')
            .addClass('default-image')
            .css('height', '')
            .attr 'src', image_path('building.svg')
          showSuccess I18n.t('account_settings.account_image.removed_success')
        else
          showError I18n.t('generic_error_message')
      error: ->
        showError I18n.t('generic_error_message')

  update: (event) =>
    @$el.find('#remove-account-image').attr('disabled', true)

    $target = $(event.target)
    originalText = $target.html()
    $target.attr('disabled', true)
    $target.html I18n.t('account_settings.account_image.loading')
    @data.process().done () => @data.submit().done (response) =>
      if response.success
        $('#main-header .account-image-container img')
          .removeClass('default-image')
          .attr 'src', response.url
        @$el.find('#remove-account-image').attr('disabled', false)
      else
        showError (response.error || I18n.t('generic_error_message'))
      $target.html originalText

